
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#4F78E8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.625 19.22a1 1 0 00-1.405.155l-3.303 4.128-1.21-1.21a1 1 0 10-1.415 1.414l2 2A1 1 0 0019 26c.02 0 .038 0 .056-.002a.996.996 0 00.726-.374l4-5a.999.999 0 00-.156-1.405zM28 12.5v16a1.5 1.5 0 01-1.5 1.5h-13a1.5 1.5 0 01-1.5-1.5v-16a1.5 1.5 0 011.5-1.5H15v1c0 1.654 1.346 3 3 3h4c1.654 0 3-1.346 3-3v-1h1.5a1.5 1.5 0 011.5 1.5zM17 12v-1a1 1 0 011-1h4a1 1 0 011 1v1a1 1 0 01-1 1h-4a1 1 0 01-1-1z","fill":"#F7F7F7"}})])
          )
        }
      }
    